let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class CategoryProductsService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.dataFilters = null;
  }
  
  getProducts(data, sales) {
    this.dataFilters = data;
    if(sales){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'POST',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.salesItems,
          cache : false,
          data : data,
          headers: {'Content-Type': 'application/json'}
        }).then((response) => {
          resolve(response.data);
        }, reason => {
          console.log('reason');
          console.log(reason);
          console.log('reason');
          reject(reason);
        });
      });
    }else {
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'POST',
          url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/show-items-by-cattegory',
          cache : false,
          data : data,
          headers: {'Content-Type': 'application/json'}
        }).then((response) => {
          resolve(response.data);
        }, reason => {
          console.log('reason');
          console.log(reason);
          console.log('reason');
          reject(reason);
        });
      });
    }
    
  }
  
  getFiltersData () {
    return this.dataFilters;
  }
  
  setFiltersData (dataFilters) {
    this.dataFilters = dataFilters;
  }
  
}

CategoryProductsService.$inject = inject;

export default CategoryProductsService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-products/category-products.service.js
 **/